import { store } from '../app/store';

export const numberToDollarFormat = (number: number | string): string => {
    return Number(Number(number).toFixed(2)).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
    });
};

export const calculateTransactionFee = (number: number): number => {
    return number * 0.035 + 0.35;
};

export const formatDateLong = (dateItem: Date): string => {
    const date = new Date(dateItem);
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    };
    return date.toLocaleDateString('en-US', options);
};

export const formatNumberToTime = (num: number): string => {
    return num.toString().padStart(2, '0');
};

export const formatToDoubleDigit = (num: number): string => {
    const rounded = Number(num.toFixed(2));
    return rounded.toString();
};

export const formatToTripleDigit = (num: number): string => {
    const rounded = Number(num.toFixed(3));
    return rounded.toString();
};

export const formatToQuadrupleDigit = (num: number): string => {
    const rounded = num.toFixed(4);
    return rounded;
};

export const isiOS = (): boolean => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

export const formatDuration = (duration: number) => {
    let seconds = Math.floor((duration / 1000) % 60),
        minutes = Math.floor((duration / (1000 * 60)) % 60),
        hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

    const hoursStr = hours < 10 ? '0' + hours : hours;
    const minutesStr = minutes < 10 ? '0' + minutes : minutes;
    const secondsStr = seconds < 10 ? '0' + seconds : seconds;

    return hoursStr + ':' + minutesStr + ':' + secondsStr;
};

export const formatDateTime = (date: Date | string) => {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return dateObj
        .toLocaleDateString('en-US', {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        })
        .replace(' at ', ', ');
};

export const roundDown = (num: number): number => {
    return Math.floor(num * 100) / 100;
};

export const roundDown4Digits = (num: number): number => {
    return Math.floor(num * 10000) / 10000;
};

export const mapLink = (address: string): string => {
    const platform = store.getState().app.platformOs;
    let addressPrefix = 'https://maps.google.com';
    if (platform === 'ios') addressPrefix = 'maps:0,0';
    else if (platform === 'android') addressPrefix = 'geo:0,0';
    return addressPrefix + '?q=' + address;
};
